import React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  {
    key: 'rawText',
    label: 'Raw Import Text',
    required: true,
    helperText: 'Exact category text as it appears in the source file (matched case-insensitively).',
  },
  {
    key: 'productCategoryId',
    label: 'Category',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/product-categories',
    displayKey: 'productCategoryName',
  },
];

// Admin view of ProductCategoryAlias — same purpose as ProductAliasManagement,
// for the Category field instead of Product.
const ProductCategoryAliasManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Category Map"
    icon={<LinkIcon />}
    apiPath="/api/product-category-aliases"
    fields={fields}
    entityLabel="Category Alias"
    softDelete={false}
  />
);

export default ProductCategoryAliasManagement;
